<script>
    // core components
    import MonedaView from "../../viewsERP/Moneda.svelte";
  </script>
  
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <MonedaView />
    </div>
  </div>